import React from "react";

export default function Textarea({
  id,
  field_name,
  label,
  error,
  borderColor,
  className,
  required,
  value,
  onChange,
  onBlur,
  setActiveElement,
}) {
  const idRef = React.useRef(id || randomId());

  return (
    <div className={`relative text-base font-normal items-center ${className}`}>
      <textarea
        id={idRef.current}
        placeholder={label}
        rows={4}
        onFocus={() => setActiveElement(field_name)}
        className={`peer border w-full block disabled:opacity-60 text-md ${
          error ? "!text-red-600" : "!text-gray-800"
        } pl-6 pr-12 py-2 bg-white
          font-normal rounded-lg placeholder-transparent outline-none ${
            error ? "ring-err-base" : ""
          } input-invalid`}
        style={{ borderColor: error ? "#dc2626" : borderColor, paddingTop: '15px' }}
        onChange={(e) => {
          onChange(field_name, e.target.value);
          setActiveElement(field_name);
        }}
        onBlur={(e) => {
          onBlur(field_name, e.target.value);
        }}
      />
      <label
        htmlFor={idRef.current}
        className={`
          absolute rounded-lg text-xs bg-white left-0 -top-2 ml-4 pt-1 px-2
          peer-focus:text-xs text-gray-400 peer-focus:peer-valid::text-prm-base peer-focus:text-prm-base
          peer-focus:-top-2 transition-all 
          peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3
          peer-placeholder-shown:text-md peer-focus:w-40
          peer-focus:h-5 peer-focus:overflow-hidden
          label-invalid ${value?.length > 0 ? "w-40 overflow-hidden h-5" : ""}
        `}
        style={{ lineHeight: "17px" }}
      >
        {label}
        {required && <span>*</span>}
      </label>
      {error && (
        <div className="text-red-600 ml-4 text-sm px-2 -bottom-1 bg-white rounded absolute">
          {error}
        </div>
      )}
    </div>
  );
}

const randomId = () => {
  const rnd = Math.round(Math.random() * 100000).toString();
  return `id-${rnd}`;
};
